<template>
	<el-row class="points-show">
		<el-col :span="24">
			<el-col :span="10">菜单管理</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addmenu(1)" plain>
					添加菜单<i class="el-icon-add"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<div>
			<el-col :span="24">
				<el-table :data="menuList" row-key="id"
					:tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
					<el-table-column prop="id" label="菜单ID"> </el-table-column>
					<el-table-column prop="authName" label="菜单名称"> </el-table-column>
					<el-table-column label="创建时间">
						<template slot-scope="scope">
							<span>{{ scope.row.createTime | formatDate }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="是否展示">
						<template slot-scope="scope">
							<!-- :disabled="scope.row.parentId != -1" -->
							<el-switch style="display: block" v-model="scope.row.status == 0" active-color="#13ce66"
								inactive-color="#ff4949" active-text="展示" inactive-text="隐藏" @change="
                  cantShow(scope.row.authName, scope.row.id, scope.row.status)
                ">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="dicId" label="操作">
						<template slot-scope="scope">
							<el-button size="mini" :disabled="scope.row.parentId != -1" @click="addmenu(3,scope.row)">
								增加子菜单
							</el-button>

							<el-button size="mini"
								@click="scope.row.parentId!=-1?addmenu(4,scope.row):addmenu(2,scope.row)">
								编辑
							</el-button>
							<el-button size="mini" type="danger" :disabled="scope.row.hasChildren"
								@click="delMenu(scope.row.id)">
								移除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
			<!-- 新建menu -->
			<el-col :span="24">
				<el-dialog
					:title="editStatus == 1?'添加菜单':(editStatus == 2 ? '编辑菜单' :( editStatus == 3 ? '添加子菜单' :( editStatus == 4? '编辑子菜单':'')))"
					:visible.sync="dialogVisible" :before-close="closeUpdate" width="30%">
					<!-- 新增父级菜单-->
					<template v-if="editStatus == 1">
						<el-form :model="addFatherform" label-position="right" label-width="120px">
							<el-form-item label="菜单名称:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="addFatherform.authName">
								</el-input>
							</el-form-item>
							<el-form-item label="页面路径:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单路径" v-model="addFatherform.path" />
							</el-form-item>
							<el-form-item label="是否显示:">
								<el-radio-group v-model="addFatherform.status">
									<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
										{{ item.title }}
									</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="菜单图标:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单图标" v-model="addFatherform.icon" />
							</el-form-item>
						</el-form>
					</template>

					<!-- 修改父级菜单-->
					<template v-if="editStatus == 2">
						<el-form :model="editFatherform" label-position="right" label-width="120px">
							<el-form-item label="菜单名称:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="editFatherform.authName">
								</el-input>
							</el-form-item>
							<el-form-item label="页面路径:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="editFatherform.path" />
							</el-form-item>
							<el-form-item label="是否显示:">
								<el-radio-group v-model="editFatherform.status">
									<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
										{{ item.title }}
									</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="菜单图标:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单图标" v-model="editFatherform.icon" />
							</el-form-item>
						</el-form>
					</template>

					<!-- 新增子级菜单-->
					<template v-if="editStatus == 3">
						<el-form :model="addSonform" label-position="right" label-width="120px">
							<el-form-item label="菜单名称:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="addSonform.authName">
								</el-input>
							</el-form-item>
							<el-form-item label="页面路径:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="addSonform.path" />
							</el-form-item>
							<el-form-item label="是否显示:">
								<el-radio-group v-model="addSonform.status">
									<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
										{{ item.title }}
									</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="菜单图标:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单图标" v-model="addSonform.icon" />
							</el-form-item>
						</el-form>
					</template>

					<!-- 修改子级菜单-->
					<template v-if="editStatus == 4">
						<el-form :model="editSonform" label-position="right" label-width="120px">
							<el-form-item label="菜单名称:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="editSonform.authName">
								</el-input>
							</el-form-item>
							<el-form-item label="页面路径:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单名称" v-model="editSonform.path" />
							</el-form-item>
							<el-form-item label="是否显示:">
								<el-radio-group v-model="editSonform.status">
									<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
										{{ item.title }}
									</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="菜单图标:">
								<el-input size="mini" :rows="5" placeholder="请输入菜单图标" v-model="editSonform.icon" />
							</el-form-item>
						</el-form>
					</template>

					<div slot="footer" class="dialog-footer">
						<el-button size="mini" @click="closeUpdate">取 消</el-button>
						<el-button size="mini" type="primary" @click="determine()">确 定</el-button>
					</div>
				</el-dialog>
			</el-col>
		</div>
	</el-row>
</template>

<script>
	var vm;
	export default {
		name: "",
		data() {
			return {
				menuList: [],
				editStatus: -1,
				dialogVisible: false,
				addFatherform: {
					authName: '',
					path: '',
					status: -1,
					icon: '',
					home: 1,
					deleteStatus: 0,
					parentId: -1
				},
				editFatherform: {
					id: '',
					authName: '',
					path: '',
					status: -1,
					icon: '',
				},
				addSonform: {
					authName: '',
					path: '',
					status: -1,
					icon: '',
					home: 1,
					deleteStatus: 0,
					parentId: ''
				},
				editSonform: {
					authName: '',
					path: '',
					status: -1,
					icon: '',
				},
				reviewStatus: [{
						title: "显示",
						type: 0,
					},
					{
						title: "隐藏",
						type: 1,
					},
				],
			};
		},
		created() {
			vm = this;
			this.getMenuList();
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			//获取菜单数据
			getMenuList() {
				this.$http.post(`/api/source/sysAuth/select`, {
					deleteStatus: 0
				}).then((res) => {
					if (res.data.status == 0) {
						console.log(res.data.data, "菜单列表");
						var list = [...res.data.data];
						list.forEach((item) => {
							if (item.sysAuths != null && item.sysAuths.length > 0) {
								item.children = [...item.sysAuths];
							}
						});
						this.menuList = [...list];
					} else {
						this.$message({
							type: "error",
							message: "系统繁忙，请稍后再试~~",
						});
					}
				});
			},
			//新增菜单
			addmenu(type, val) {
				this.editStatus = type;
				switch (type) {
					case 2:
						//编辑父级菜单
						this.editFatherform.authName = val.authName
						this.editFatherform.id = val.id
						this.editFatherform.path = val.path
						this.editFatherform.status = val.status
						this.editFatherform.icon = val.icon
						break;
					case 3:
						//新增子级菜单
						this.addSonform.parentId = val.id
						break;
					case 4:
						//编辑子级菜单
						this.editSonform.id = val.id
						this.editSonform.authName = val.authName
						this.editSonform.path = val.path
						this.editSonform.status = val.status
						this.editSonform.icon = val.icon
						break;
				}
				this.dialogVisible = true;
			},
			//修改菜单显示隐藏
			cantShow(authName, id, status) {
				status = status == 0 ? 1 : 0;
				this.$http
					.get(`/api/source/sysAuth/upodateStatus/${id}/${status}`, {})
					.then((res) => {
						if (res.data.status == 0) {
							var statusText = status != 0 ? "隐藏" : "展示";
							if (status != 0) {
								this.$message.error(authName + "已" + statusText);
							} else {
								this.$message.success(authName + "已" + statusText);
							}
							this.getMenuList();
						} else {
							this.$message.error("发生未可知错误，请联系开发人员");
						}
					});
			},
			//确定
			determine() {
				var _this = this
				switch (this.editStatus) {
					case 1:
						if (
							!this.addFatherform.authName.trim() ||
							this.addFatherform.status < 0
						) {
							return this.$message({
								type: "error",
								message: "请填写完整菜单信息再提交~~",
							});
						}
						var data = {
							...this.addFatherform
						}
						this.$http
							.post(`/api/source/sysAuth/insert`, data)
							.then((res) => {
								if (res.data) {
									this.$message({
										type: "success",
										message: "添加菜单成功！！",
									});
									_this.getMenuList();
									_this.closeUpdate(1);
								} else {
									this.$message({
										type: "error",
										message: "系统繁忙，请稍后再试~~",
									});
								}
							});
						break;
					case 2:
						//编辑父级菜单
						if (
							!this.editFatherform.authName.trim() ||
							this.editFatherform.status < 0
						) {
							return this.$message({
								type: "error",
								message: "请填写完整菜单信息再提交~~",
							})
						}
						var data = {
							...this.editFatherform
						}
						this.$http
							.post(`/api/source/sysAuth/update`, data)
							.then((res) => {
								if (res.data) {
									this.$message({
										type: "success",
										message: "修改菜单成功！！",
									});
									_this.getMenuList();
									_this.closeUpdate(1);
								} else {
									this.$message({
										type: "error",
										message: "系统繁忙，请稍后再试~~",
									});
								}
							})
						break;
					case 3:
						//新增子级菜单
						if (
							!this.addSonform.authName.trim() ||
							this.addSonform.status < 0
						) {
							return this.$message({
								type: "error",
								message: "请填写完整菜单信息再提交~~",
							});
						}
						var data = {
							...this.addSonform
						}
						this.$http
							.post(`/api/source/sysAuth/insert`, data)
							.then((res) => {
								if (res.data) {
									this.$message({
										type: "success",
										message: "添加子菜单成功！！",
									});
									_this.getMenuList();
									_this.closeUpdate(1);
								} else {
									this.$message({
										type: "error",
										message: "系统繁忙，请稍后再试~~",
									});
								}
							});
						break;
					case 4:
						//编辑子级菜单
						if (
							!this.editSonform.authName.trim() ||
							this.editSonform.status < 0
						) {
							return this.$message({
								type: "error",
								message: "请填写完整菜单信息再提交~~",
							});
						}
						var data = {
							...this.editSonform
						}
						this.$http
							.post(`/api/source/sysAuth/update`, data)
							.then((res) => {
								if (res.data) {
									this.$message({
										type: "success",
										message: "修改子菜单成功！！",
									});
									_this.getMenuList();
									_this.closeUpdate(1);
								} else {
									this.$message({
										type: "error",
										message: "系统繁忙，请稍后再试~~",
									});
								}
							})
						break;
				}
			},
			//弹框隐藏
			closeUpdate(type) {
				this.addFatherform = {
					authName: '',
					path: '',
					status: '',
					icon: '',
					home: 1,
					deleteStatus: 0,
					parentId: -1
				}
				this.editFatherform = {
					authName: '',
					path: '',
					status: '',
					icon: '',
				}
				this.addSonform = {
					authName: '',
					path: '',
					status: '',
					icon: '',
					home: 1,
					deleteStatus: 0,
					parentId: ''
				}
				this.editSonform = {
					authName: '',
					path: '',
					status: '',
					icon: '',
				}
				if (type && type == 1) {
					this.$notify({
						title: '温馨提示',
						message: '操作成功后，点击右上角退出重新登录即可生效哦！！',
						type: 'success',
						duration: 6000
					});
				}

				this.dialogVisible = false
			},
			//删除菜单
			delMenu(id) {
				this.$confirm('此操作将删除该项菜单吗？, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysAuth/deleteById/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getMenuList()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			}


		},
	};
</script>

<style scoped lang="less">
</style>
